(ns iris.dev.subs
  (:require
   [re-frame.core :as re-frame]))


(re-frame/reg-sub
 ::tracker
 (fn [db]
   (:tracker db)))